import { PREMIUM_FEATURES } from "@common/flatRateBilling";
import { useAllowFeature } from "@hooks/useAllowFeature";
import { ArAgingDetailPage } from "./ArAgingDetailPage";
import { ArAgingReportsPaywalled } from "./ArAgingReportsPaywalled";

export const ArAgingDetailPageWrapper = () => {
    const { hasAccess, isFetched } = useAllowFeature(
        PREMIUM_FEATURES.ACCRUAL_LEDGER,
    );

    if (!isFetched) {
        return null;
    }

    if (!hasAccess) {
        return <ArAgingReportsPaywalled />;
    }

    return <ArAgingDetailPage />;
};
